import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";

//components
import { NewBackButton, SearchIcon } from "../../../components/svgs";
import { StyledText } from "../../../components/common/basic";

// theme
import { useTheme, useTrivia } from "../../../hooks";
import { Desktop } from "../../../containers/common";
import PlayTriviaModal from "./PlayTriviaModal";
import TriviaInfoModal from "./TriviInfoModal";
import { useLocation } from "react-router-dom";

import { OfferAlertModal } from "../../../components/loyalty";

const LocationSelectionPage = () => {
  const [playTriviaModal, setPlayTriviaModal] = useState(false);
  const [triviInfoModal, setTriviaInfoModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [isFocused, setIsFocused] = useState(false);
  const [showModalUnavailable, setModalUnavailable] = useState(false);
  const [unavailableMsg, setModalUnavailableMsg] = useState(
    "This trivia is currently unavailable in your location."
  );

  const { locationSelected, setIsLocationSelected, activeTrivia, activeTriviaCategory } = useTrivia();

  useEffect(() => {
    if (activeTrivia.rewardScheme === "online" && !activeTrivia?.requireLocation) {
      setIsLocationSelected(true);
      setPlayTriviaModal(true);
    }
  }, [activeTrivia?.rewardScheme])

  const { themeContext, theme } = useTheme();

  let history = useHistory();

  let mashupBackground =
    theme.colors[themeContext.activeTheme]["mashupBackground"];
  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];

  const location = useLocation();
  const { item = [] } = location.state || {};

  const filteredRegions = item.filter((region) =>
    region.label.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSearchInputFocus = () => {
    setIsFocused(true);
  };

  return (
    <>
      <MainHolder>
        <Children>
          <div
            style={{
              width: "70%",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <BackButtonContainer
              onClick={() => {
                history.goBack();
              }}
              style={{ zIndex: 100, marginLeft: 20 }}
            >
              <NewBackButton />
            </BackButtonContainer>
            <StyledText style={{ marginLeft: 20 }}>
              Select Your location
            </StyledText>
          </div>

          <DescriptionBody color={mashupBackground}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                border: "1px solid #C8CBCB",
                padding: 15,
                width: "80%",
                borderRadius: 15,
              }}
            >
              <input
                onFocus={handleSearchInputFocus}
                placeholder="Search for region"
                style={{
                  border: "none",
                  fontFamily: "MTNRegular",
                  outline: isFocused ? "none" : "none",
                }}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              ></input>
              <SearchIcon fill="#797979" />
            </div>
            {filteredRegions.map((region, index) => (
              <div
                style={{
                  width: "80%",
                  backgroundColor: index === 0 ? background : "white",
                  boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2)",
                  borderRadius: 8,
                  margin: 10,
                  paddingInline: 15,
                  overflow: "auto",
                  color: index === 0 ? "white" : "black",
                }}
                onClick={() => {
                  if (!activeTrivia?.whiteListedLocations.includes(region.label)) {
                    setModalUnavailable(true);
                  } else {
                    setPlayTriviaModal(true);
                  }

                  setIsLocationSelected(true);
                }}
              >
                <StyledText>{region.label}</StyledText>
              </div>
            ))}
          </DescriptionBody>
        </Children>
      </MainHolder>
      {playTriviaModal && (
        <PlayTriviaModal onBackDropClick={() => {
          if (activeTriviaCategory?.isMultiTrivia) {
            history.push('/trivia/trivia')
          } else {
            history.push('/trivia/trivia-category')
          }
        }} />
      )}
      {triviInfoModal && (
        <TriviaInfoModal onBackButtonClick={() => setTriviaInfoModal(false)} />
      )}
      {showModalUnavailable && (
        <OfferAlertModal
          background={background}
          hideModal={() => {
            setModalUnavailable(false);
            history.push(`/trivia/trivia-category`);
          }}
          title="Trivia not available"
          description={unavailableMsg}
        />
      )}
    </>
  );
};

const MainHolder = styled.div`
  overflow: hidden;
  scrollbar-width: none;
  /* background-color: ${({ activeTheme }) => activeTheme}; */
  background-color: white;
  height: 700px;
  position: relative;
  @media screen and (max-width: 480px) {
    border-radius: 0px;
    padding-bottom: 5px;
    height: 100vh;
  }
`;

const Children = styled.div`
  height: 100%;
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const BackButtonContainer = styled.div`
  background-color: #ffcc00;
  width: 30px;
  height: 30px;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  //   position: absolute;
  margin: 8px;
`;

const DescriptionBody = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  background-color: ${({ color }) => color};
  align-items: center;
`;

export default LocationSelectionPage;
